// extracted by mini-css-extract-plugin
export var arrow = "cv_dG";
export var check = "cv_j6";
export var details = "cv_j2";
export var icon = "cv_j";
export var info = "cv_j3";
export var list = "cv_gZ";
export var more = "cv_j5";
export var remove = "cv_j7";
export var ribbon = "cv_j4";
export var row = "cv_fM";